import {Typography, TypographyProps} from '@material-ui/core'

type Props = TypographyProps & {
  children: React.ReactNode
  style?: any
}
const Subtitle1: React.FC<Props> = (props: Props) => {
  let color = props.color
  if (!color) {
    color = 'textPrimary'
  }
  return (
    <Typography variant="subtitle1" {...props} color={color} style={{...props.style}}>
      {props.children}
    </Typography>
  )
}

export default Subtitle1
